


































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { RelatorioServicosVeicularesModel } from "@/models/administracao/servicos-veiculares/RelatorioServicosVeicularesModel";
import {
  EstadosCidades,
  EstadosCidadesResponse,
} from "@/models/estados-cidades";
import { tipoServicoVeicularList } from "@/models/commons/TipoServicoModel";
import { statusServicos } from "@/models/commons/StatusServicosModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GerencialServicosVeicularesService from "@/service/relatorio/gerencial/GerencialServicosVeicularesService";
import axios, { AxiosResponse } from "axios";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
  },
})
export default class RelatorioServicosVeiculares extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
  };

  exibirLista = false;
  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;
  collapsibleOpened = false;

  estados: EstadosCidades[] = [];
  cidades: string[] = [];
  tipoServicos = tipoServicoVeicularList;
  status = statusServicos;
  perfis = [
    { valor: "PF", descricao: "Pessoa Física" },
    { valor: "PJ", descricao: "Pessoa Jurídica" },
  ];
  categorias = [
    { valor: "ASSISTENCIA_24H", descricao: "Assistência 24h" },
    { valor: "ORCAMENTO_AUTOMOTIVO", descricao: "Orçamento Automotivo Online" },
  ];
  relatorio: RelatorioServicosVeicularesModel = {
    inicio: undefined,
    fim: undefined,
  };

  headers = [
    { text: 'Nº Solicitação', value: 'numeroSolicitacao', width: '150px' },
    { text: 'Cliente', value: 'nomeCliente', width: '250px'  },
    { text: 'Data Cadastro', value: 'dataCadastro', width: '150px' },
    { text: 'Perfil', value: 'perfil', width: '150px'  },
    { text: 'Cidade', value: 'cidade', width: '150px'},
    { text: 'Estado', value: 'estado', width: '150px'},
    { text: 'Prestador', value: 'nomePrestador', width: '250px'},
    { text: 'Tipo Serviço', value: 'tipoServico', width: '150px'},
    { text: 'Categoria', value: 'categoria', width: '150px'},
    { text: 'Status', value: 'status', width: '250px'},
    { text: 'Valor Serviço', value: 'valor', width: '150px'},
    { text: 'Custo Médio', value: 'custoMedio', width: '150px'},
    { text: 'Avaliação Serviço', value: 'avaliacao', width: '150px'},
  ];

  items = [];

  mounted() {
    axios
      .get<EstadosCidadesResponse>("/administrativo/json/estados-cidades.json")
      .then((resp) => (this.estados = resp.data.estados));
  }

  @Watch("relatorio.estado")
  private selectCities(): void {
    if (this.relatorio.estado) {
      this.cidades = this.estados.filter(
        (v) => v.sigla === this.relatorio.estado?.sigla
      )[0].cidades;
    }
  }

  getData() {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        GerencialServicosVeicularesService.dadosRelatorioServicosVeiculares(this.relatorio)
          .then((res) => {
            this.loading = false;
            this.exibirLista = true;
            this.items = res.data;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
            this.exibirLista = false;
          });

        //this.limparformulario();
      }
    });
  }

  public gerarRelatorio(tipo: string): void {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        GerencialServicosVeicularesService.gerarRelatorio(tipo, this.relatorio)
          .then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data]));

            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            fileLink.setAttribute(
              "download",
              `relatorio_servicos_veiculares.${
                tipo.toLowerCase() === "excel" ? "xls" : "pdf"
              }`
            );

            document.body.appendChild(fileLink);

            fileLink.click();

            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        this.limparformulario();
      }
    });
  }

  public toggleCollapsible(): void {
    this.collapsibleOpened = !this.collapsibleOpened;
  }

  public limparformulario(): void {
    this.relatorio = {};
    this.$refs.relatorioObserver.reset();
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }
}
